<ion-row class="payment-row">
  <ion-col size="2" data-cy="payment-row-reference-number">
    <div>
      <a (click)="onReferenceNumberClick()" href="javascript:void(0)">
        #{{ vm?.referenceNumber }}
      </a>
    </div>
  </ion-col>

  <ion-col size="2" data-cy="payment-row-payment-method">
    <div class="payment-text">
      {{ 'i18n.payments.paymentMethod.' + vm?.paymentMethod | translate }}
    </div>
  </ion-col>

  <ion-col size="1.5" data-cy="payment-row-payment-date">
    {{ vm?.paymentDate | date: 'M/d/yyyy':'GMT' }}
  </ion-col>

  <ion-col size="1.3" data-cy="payment-row-items-count">
    <div>
      {{ vm?.itemCount }}
    </div>
  </ion-col>

  <ion-col size="1.5" data-cy="payment-row-customer-count">
    <div>
      {{ vm?.customerCount }}
    </div>
  </ion-col>

  <ion-col size="1.7" data-cy="payment-row-payment-amount">
    {{ vm?.totalPaymentAmount | currency }}
  </ion-col>

  <ion-col size="1.5" data-cy="payment-row-status">
    <span
      class="payment-status-circle"
      [ngClass]="{
        red: vm?.status === Status.PENDING
      }"
    ></span>
    <span>{{ vm?.status | titlecase }}</span>
  </ion-col>

  <ion-col *ngIf="shouldShowButtons" class="ion-align-self-end">
    <div class="buttons-column" *ngIf="showButtons">
      <ion-icon
        color="success"
        name="ellipsis-vertical"
        data-cy="payment-row-more-options-desktop-btn"
        (click)="onMoreOptionsClick($event)"
      >
      </ion-icon>
    </div>
  </ion-col>
</ion-row>
